import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingButtons from '../../components/feature/FloatingButtons';

const HomePage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [counters, setCounters] = useState({
    years: 0,
    professionals: 0,
    customers: 0,
    workers: 0
  });

  const slides = [
    {
      title: 'İş Sağlığı ve Güvenliğinde',
      subtitle: 'Profesyonel Çözüm Ortağınız',
      highlight: 'ASSA OSGB',
      ending: 'ile güvenli yarınlar...',
      image: 'https://public.readdy.ai/ai/img_res/192cf09096765f854d4680dd4dab7612.jpg',
      gradient: 'from-sky-600/90 via-sky-700/85 to-blue-800/90'
    },
    {
      title: 'Sağlıklı Çalışanlar',
      subtitle: 'Güvenli İş Yerleri',
      highlight: 'Mutlu Yarınlar',
      ending: 'için ASSA OSGB',
      image: 'https://readdy.ai/api/search-image?query=Happy%20diverse%20workers%20in%20modern%20industrial%20facility%20wearing%20safety%20equipment%20and%20hard%20hats%2C%20smiling%20team%20members%20in%20clean%20bright%20manufacturing%20environment%2C%20professional%20safety%20culture%20with%20modern%20machinery%20and%20safety%20signage%2C%20positive%20workplace%20atmosphere%20with%20natural%20lighting%20and%20organized%20workspace&width=1920&height=1080&seq=slider2&orientation=landscape',
      gradient: 'from-red-800/90 via-red-900/85 to-red-950/90'
    },
    {
      title: 'Assa CRM ile',
      subtitle: 'İş Sağlığı ve Güvenliğinde',
      subtitle2: 'Dijital Dönüşüm',
      highlight: 'Geleceğe Hazır Olun',
      ending: '',
      image: 'https://readdy.ai/api/search-image?query=Futuristic%20digital%20technology%20interface%20with%20holographic%20safety%20data%20displays%20and%20modern%20workspace%2C%20professional%20using%20advanced%20digital%20safety%20management%20software%20on%20large%20touchscreen%2C%20sleek%20contemporary%20office%20with%20blue%20ambient%20lighting%20and%20high-tech%20equipment%2C%20innovative%20digital%20transformation%20concept%20with%20clean%20minimalist%20design&width=1920&height=1080&seq=slider3&orientation=landscape',
      gradient: 'from-gray-900/90 via-slate-800/85 to-gray-950/90'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  // Counter Animation
  useEffect(() => {
    const targets = {
      years: 14,
      professionals: 131,
      customers: 630,
      workers: 32500
    };

    const duration = 2000; // 2 seconds
    const steps = 60;
    const interval = duration / steps;

    const incrementValues = {
      years: targets.years / steps,
      professionals: targets.professionals / steps,
      customers: targets.customers / steps,
      workers: targets.workers / steps
    };

    let currentStep = 0;

    const timer = setInterval(() => {
      currentStep++;
      
      if (currentStep <= steps) {
        setCounters({
          years: Math.min(Math.round(incrementValues.years * currentStep), targets.years),
          professionals: Math.min(Math.round(incrementValues.professionals * currentStep), targets.professionals),
          customers: Math.min(Math.round(incrementValues.customers * currentStep), targets.customers),
          workers: Math.min(Math.round(incrementValues.workers * currentStep), targets.workers)
        });
      } else {
        clearInterval(timer);
        setCounters(targets);
      }
    }, interval);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    // SEO Meta Tags
    document.title = 'Adana OSGB | Mersin Hatay Osmaniye İş Sağlığı Güvenliği Hizmetleri | ASSA';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Adana OSGB hizmetleri, Mersin OSGB, Hatay OSGB, Osmaniye OSGB iş sağlığı ve güvenliği uzmanı. İşyeri hekimi, iş güvenliği uzmanı, risk değerlendirmesi, İSG eğitimleri. 14 yıllık deneyim, 630+ işletme, 32.500+ çalışan.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Adana OSGB, Mersin OSGB, Hatay OSGB, Osmaniye OSGB, iş sağlığı ve güvenliği, işyeri hekimi, iş güvenliği uzmanı, risk değerlendirmesi, İSG eğitimi');
    }

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://www.assaosgb.com.tr/');
    }

    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "ASSA İş Sağlığı ve Güvenliği",
      "alternateName": "ASSA OSGB",
      "url": "https://www.assaosgb.com.tr",
      "logo": "https://static.readdy.ai/image/69983b9b992309f9f345f22b715baa7c/9064e6cef4f3a2eddd558022a58e0363.png",
      "description": "Adana, Mersin, Hatay, Osmaniye bölgelerinde iş sağlığı ve güvenliği hizmetleri. İşyeri hekimi, iş güvenliği uzmanı, OSGB danışmanlığı, risk değerlendirmesi, İSG eğitimleri.",
      "foundingDate": "2010",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Reşatbey Mahallesi, 62015 Sokak No:4, ASSA Plaza",
        "addressLocality": "Seyhan",
        "addressRegion": "Adana",
        "postalCode": "01120",
        "addressCountry": "TR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "36.99703549102141",
        "longitude": "35.326921312280646"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+90-850-346-2772",
        "contactType": "customer service",
        "areaServed": ["TR"],
        "availableLanguage": ["Turkish"]
      },
      "sameAs": [
        "https://www.instagram.com/assaosgb",
        "https://www.facebook.com/assaosgb",
        "https://twitter.com/assaosgb",
        "https://www.youtube.com/channel/UCeUi5Ttxt9K3qKJMr753s-A"
      ],
      "areaServed": [
        {"@type": "City", "name": "Adana"},
        {"@type": "City", "name": "Mersin"},
        {"@type": "City", "name": "Hatay"},
        {"@type": "City", "name": "Osmaniye"}
      ]
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Ultra Modern Hero Slider */}
      <section className="relative h-screen overflow-hidden mt-20">
        {/* Background Slides with Images */}
        <div className="absolute inset-0">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-all duration-1000 ease-in-out ${
                index === currentSlide ? 'opacity-100 scale-100' : 'opacity-0 scale-105'
              }`}
            >
              {/* Background Image */}
              <div className="absolute inset-0">
                <img 
                  src={slide.image} 
                  alt={slide.title}
                  className="w-full h-full object-cover"
                />
              </div>
              
              {/* Gradient Overlay */}
              <div className={`absolute inset-0 bg-gradient-to-r ${slide.gradient}`}></div>
              
              {/* Animated Mesh Gradient */}
              <div className="absolute inset-0 opacity-30">
                <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-white/10 via-transparent to-transparent animate-pulse"></div>
              </div>
              
              {/* Floating Particles */}
              <div className="absolute inset-0 overflow-hidden opacity-20">
                <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-white rounded-full animate-ping" style={{animationDuration: '3s', animationDelay: '0s'}}></div>
                <div className="absolute top-1/3 right-1/3 w-2 h-2 bg-white rounded-full animate-ping" style={{animationDuration: '4s', animationDelay: '1s'}}></div>
                <div className="absolute bottom-1/4 left-1/3 w-2 h-2 bg-white rounded-full animate-ping" style={{animationDuration: '3.5s', animationDelay: '2s'}}></div>
                <div className="absolute bottom-1/3 right-1/4 w-2 h-2 bg-white rounded-full animate-ping" style={{animationDuration: '4.5s', animationDelay: '0.5s'}}></div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Content Container */}
        <div className="relative z-10 container mx-auto px-4 h-full flex items-center">
          <div className="text-white max-w-4xl">
            <div className="space-y-6">
              {/* Animated Title */}
              <div className="overflow-hidden">
                <h1 
                  className={`text-5xl md:text-7xl font-bold leading-tight transform transition-all duration-1000 ease-out ${
                    currentSlide >= 0 ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
                  }`}
                  style={{transitionDelay: '300ms'}}
                >
                  {slides[currentSlide]?.title}
                </h1>
              </div>
              
              {/* Animated Subtitle */}
              <div className="overflow-hidden">
                <h2 
                  className={`text-3xl md:text-5xl font-semibold transform transition-all duration-1000 ease-out ${
                    currentSlide >= 0 ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
                  }`}
                  style={{transitionDelay: '500ms'}}
                >
                  {slides[currentSlide]?.subtitle}
                </h2>
              </div>
              
              {/* Animated Subtitle2 */}
              {slides[currentSlide]?.subtitle2 && (
                <div className="overflow-hidden">
                  <h3 
                    className={`text-2xl md:text-4xl font-medium transform transition-all duration-1000 ease-out ${
                      currentSlide >= 0 ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
                    }`}
                    style={{transitionDelay: '700ms'}}
                  >
                    {slides[currentSlide].subtitle2}
                  </h3>
                </div>
              )}
              
              {/* Animated Highlight */}
              <div className="overflow-hidden">
                <div 
                  className={`text-4xl md:text-6xl font-bold transform transition-all duration-1000 ease-out ${
                    currentSlide >= 0 ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
                  }`}
                  style={{transitionDelay: '900ms'}}
                >
                  <span className="bg-gradient-to-r from-red-400 via-red-500 to-red-600 bg-clip-text text-transparent drop-shadow-2xl">
                    {slides[currentSlide]?.highlight}
                  </span>
                  {slides[currentSlide]?.ending && (
                    <span className="text-white ml-3">
                      {slides[currentSlide].ending}
                    </span>
                  )}
                </div>
              </div>
              
              {/* Animated CTA Buttons */}
              <div className="overflow-hidden pt-8">
                <div 
                  className={`flex flex-wrap gap-4 transform transition-all duration-1000 ease-out ${
                    currentSlide >= 0 ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
                  }`}
                  style={{transitionDelay: '1100ms'}}
                >
                  <Link 
                    to="/iletisim"
                    className="group inline-flex items-center bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300 transform hover:scale-105 shadow-2xl hover:shadow-red-500/50 whitespace-nowrap cursor-pointer"
                  >
                    <span>Hemen İletişime Geçin</span>
                    <i className="ri-arrow-right-line ml-3 text-xl group-hover:translate-x-1 transition-transform"></i>
                  </Link>
                  
                  <Link 
                    to="/kurumsal"
                    className="group inline-flex items-center bg-white/10 backdrop-blur-md border-2 border-white/30 hover:bg-white/20 text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
                  >
                    <span>Hakkımızda</span>
                    <i className="ri-information-line ml-3 text-xl group-hover:rotate-12 transition-transform"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Modern Progress Indicators */}
        <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 flex items-center space-x-4 bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-6 py-3">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`relative group transition-all duration-300 ${
                index === currentSlide ? 'w-16' : 'w-3'
              }`}
              onClick={() => goToSlide(index)}
            >
              <div className={`h-3 rounded-full transition-all duration-300 ${
                index === currentSlide 
                  ? 'bg-gradient-to-r from-red-500 to-red-600 shadow-lg shadow-red-500/50' 
                  : 'bg-white/40 group-hover:bg-white/60'
              }`}>
                {index === currentSlide && (
                  <div className="absolute inset-0 bg-white/30 rounded-full animate-pulse"></div>
                )}
              </div>
            </button>
          ))}
        </div>

        {/* Elegant Navigation Arrows */}
        <button 
          className="absolute left-8 top-1/2 transform -translate-y-1/2 group z-20"
          onClick={() => goToSlide(currentSlide === 0 ? slides.length - 1 : currentSlide - 1)}
        >
          <div className="w-14 h-14 bg-white/10 backdrop-blur-md border border-white/20 rounded-full flex items-center justify-center text-white hover:bg-white/20 transition-all duration-300 group-hover:scale-110 cursor-pointer">
            <i className="ri-arrow-left-line text-2xl group-hover:-translate-x-1 transition-transform"></i>
          </div>
        </button>
        <button 
          className="absolute right-8 top-1/2 transform -translate-y-1/2 group z-20"
          onClick={() => goToSlide((currentSlide + 1) % slides.length)}
        >
          <div className="w-14 h-14 bg-white/10 backdrop-blur-md border border-white/20 rounded-full flex items-center justify-center text-white hover:bg-white/20 transition-all duration-300 group-hover:scale-110 cursor-pointer">
            <i className="ri-arrow-right-line text-2xl group-hover:translate-x-1 transition-transform"></i>
          </div>
        </button>

        {/* Scroll Indicator */}
        <div className="absolute bottom-12 right-12 animate-bounce">
          <div className="w-8 h-12 border-2 border-white/30 rounded-full flex items-end justify-center p-2">
            <div className="w-1.5 h-3 bg-white rounded-full animate-pulse"></div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <span className="text-red-600 font-medium">Biz Kimiz ?</span>
            <h2 className="text-4xl font-bold text-gray-800 mt-2">HAKKIMIZDA</h2>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <img src="https://readdy.ai/api/search-image?query=Professional%20workplace%20safety%20team%20meeting%20in%20modern%20office%2C%20business%20people%20discussing%20safety%20protocols%20with%20documents%20and%20charts%2C%20clean%20corporate%20environment&width=300&height=200&seq=27&orientation=landscape" alt="About 1" className="w-full h-48 rounded-lg shadow-lg object-cover" />
                <img src="https://readdy.ai/api/search-image?query=Industrial%20safety%20training%20session%20with%20workers%20wearing%20safety%20equipment%2C%20professional%20instructor%20teaching%20safety%20procedures%20in%20modern%20facility&width=300&height=200&seq=28&orientation=landscape" alt="About 2" className="w-full h-48 rounded-lg shadow-lg object-cover" />
              </div>
              <div className="space-y-4">
                <img src="https://readdy.ai/api/search-image?query=Modern%20healthcare%20facility%20with%20medical%20equipment%20and%20professional%20staff%2C%20clean%20medical%20environment%20with%20safety%20protocols%20and%20examination%20room&width=300&height=200&seq=29&orientation=landscape" alt="About 3" className="w-full h-48 rounded-lg shadow-lg object-cover" />
                <img src="https://readdy.ai/api/search-image?query=Professional%20occupational%20health%20and%20safety%20expert%20with%20hard%20hat%20and%20clipboard%20in%20industrial%20workplace%2C%20safety%20inspection%20and%20documentation&width=300&height=200&seq=30&orientation=landscape" alt="About 4" className="w-full h-48 rounded-lg shadow-lg object-cover" />
              </div>
            </div>

            <div>
              <p className="text-gray-600 leading-relaxed mb-8 text-justify">
                ASSA İş Sağlığı ve Güvenliği LTD. ŞTİ. Türkiye'de iş sağlığı ve güvenliği kültürünü oluşturmak adına bine yakın işletmeye ve on binlerce çalışana hizmet vermektedir. ASSA OSGB, yenilikçi ve profesyonel bir bakış açısı ile bir kuruluşun sağlık ve güvenlik risklerini tutarlı bir şekilde belirlemesine ve kontrol etmesine, olay potansiyelini azaltmasına, sağlık ve güvenlik mevzuatına uyumun sağlanmasına yardımcı olması ve performansını sürekli olarak iyileştirmesine olanak tanıyan bir kurumdur.
                <br /><br />
                Yönetim kadrosu ve sektörel farkındalıkları olan nitelikli İş Sağlığı ve Güvenliği Profesyonelleriyle; çalışanların ruhsal ve fiziksel açıdan sağlıklı bir şekilde evlerine dönebilmelerini amaçlayan yenilikçi bir kurumdur.
              </p>
              <Link to="/kurumsal" className="bg-red-600 text-white px-8 py-3 rounded-lg hover:bg-red-700 transition-colors inline-block whitespace-nowrap cursor-pointer">
                Devamını Oku
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Counter Section */}
      <section className="py-20 bg-gradient-to-br from-indigo-700 via-indigo-600 to-blue-700 text-white relative overflow-hidden">
        {/* Modern Background Elements */}
        <div className="absolute inset-0">
          <div className="absolute top-10 left-10 w-32 h-32 border border-white/10 rounded-full animate-pulse"></div>
          <div className="absolute top-32 right-20 w-24 h-24 border border-white/10 rounded-full animate-pulse delay-1000"></div>
          <div className="absolute bottom-20 left-32 w-40 h-40 border border-white/10 rounded-full animate-pulse delay-2000"></div>
          <div className="absolute bottom-32 right-10 w-28 h-28 border border-white/10 rounded-full animate-pulse delay-500"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-indigo-700/50 to-transparent"></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">Rakamlarla ASSA OSGB</h2>
            <p className="text-indigo-200 text-lg max-w-2xl mx-auto">
              Yılların deneyimi ve binlerce mutlu müşterinin güveniyle büyüyen başarı hikayemiz
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Experience Card */}
            <div className="group bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-2 border border-white/20">
              <div className="w-20 h-20 bg-gradient-to-br from-red-500 to-red-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-time-line text-3xl text-white"></i>
              </div>
              <div className="text-5xl font-bold mb-2 bg-gradient-to-r from-white to-indigo-200 bg-clip-text text-transparent">{counters.years}+</div>
              <div className="text-indigo-200 font-medium text-lg">Yıllık Deneyim</div>
              <div className="text-indigo-300 text-sm mt-2">2010'dan beri hizmetinizdeyiz</div>
            </div>

            {/* Professionals Card */}
            <div className="group bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-2 border border-white/20">
              <div className="w-20 h-20 bg-gradient-to-br from-amber-500 to-amber-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-user-star-line text-3xl text-white"></i>
              </div>
              <div className="text-5xl font-bold mb-2 bg-gradient-to-r from-white to-indigo-200 bg-clip-text text-transparent">{counters.professionals}+</div>
              <div className="text-indigo-200 font-medium text-lg">İSG Profesyoneli</div>
              <div className="text-indigo-300 text-sm mt-2">Uzman kadromuz</div>
            </div>

            {/* Happy Customers Card */}
            <div className="group bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-2 border border-white/20">
              <div className="w-20 h-20 bg-gradient-to-br from-yellow-500 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-emotion-happy-line text-3xl text-white"></i>
              </div>
              <div className="text-5xl font-bold mb-2 bg-gradient-to-r from-white to-indigo-200 bg-clip-text text-transparent">{counters.customers}+</div>
              <div className="text-indigo-200 font-medium text-lg">Mutlu Müşteri</div>
              <div className="text-indigo-300 text-sm mt-2">Güvenilir iş ortağı</div>
            </div>

            {/* Protected Workers Card */}
            <div className="group bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-2 border border-white/20">
              <div className="w-20 h-20 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-shield-user-line text-3xl text-white"></i>
              </div>
              <div className="text-5xl font-bold mb-2 bg-gradient-to-r from-white to-indigo-200 bg-clip-text text-transparent">{counters.workers.toLocaleString('tr-TR')}+</div>
              <div className="text-indigo-200 font-medium text-lg">Korunan Çalışan</div>
              <div className="text-indigo-300 text-sm mt-2">Güvenli çalışma ortamı</div>
            </div>
          </div>
          
          {/* Bottom Decorative Line */}
          <div className="mt-16 flex justify-center">
            <div className="w-32 h-1 bg-gradient-to-r from-transparent via-white/50 to-transparent rounded-full"></div>
          </div>
        </div>
      </section>

      {/* Training & Consultancy Section */}
      <section className="py-20 bg-white relative overflow-hidden">
        {/* Background Elements */}
        <div className="absolute inset-0">
          <div className="absolute top-20 left-10 w-64 h-64 bg-gradient-to-br from-red-100 to-red-50 rounded-full opacity-30 animate-pulse"></div>
          <div className="absolute bottom-20 right-10 w-80 h-80 bg-gradient-to-br from-teal-100 to-teal-50 rounded-full opacity-30 animate-pulse delay-1000"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-gradient-to-br from-green-100 to-green-50 rounded-full opacity-20 animate-pulse delay-2000"></div>
        </div>

        <div className="container mx-auto px-4 relative z-10">
          {/* Section Header */}
          <div className="text-center mb-16">
            <span className="text-red-600 font-medium text-lg">Uzman Kadromuzla</span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mt-2 mb-6">EĞİTİM & DANIŞMANLIK</h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto leading-relaxed">
              İş sağlığı ve güvenliği alanında kapsamlı eğitim programları ve profesyonel danışmanlık hizmetleri ile 
              işletmenizin güvenli çalışma kültürünü oluşturuyoruz.
            </p>
          </div>

          {/* Training Section */}
          <div className="mb-20">
            <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-2xl p-8 border border-red-200">
              <div className="flex items-center justify-center mb-8">
                <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-red-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-graduation-cap-line text-2xl text-white"></i>
                </div>
                <h3 className="text-3xl font-bold text-gray-800">Eğitim Programları</h3>
              </div>
              <p className="text-gray-700 leading-relaxed mb-8 text-center max-w-3xl mx-auto">
                Çalışanlarınızın güvenli çalışma bilincini artırmak için özel olarak tasarlanmış 
                kapsamlı eğitim programları sunuyoruz.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <div className="bg-white rounded-lg p-6 shadow-sm border border-red-100 hover:shadow-lg transition-shadow">
                  <div className="flex items-center mb-3">
                    <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center mr-3">
                      <i className="ri-shield-check-line text-red-600 text-xl"></i>
                    </div>
                    <span className="font-semibold text-gray-800">İSG Temel Eğitimi</span>
                  </div>
                  <p className="text-sm text-gray-600">Temel güvenlik bilinci oluşturma ve iş sağlığı güvenliği mevzuatı</p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-red-100 hover:shadow-lg transition-shadow">
                  <div className="flex items-center mb-3">
                    <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center mr-3">
                      <i className="ri-building-line text-red-600 text-xl"></i>
                    </div>
                    <span className="font-semibold text-gray-800">Yüksekte Çalışma</span>
                  </div>
                  <p className="text-sm text-gray-600">Yüksek risk alanları için özel eğitim ve güvenlik önlemleri</p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-red-100 hover:shadow-lg transition-shadow">
                  <div className="flex items-center mb-3">
                    <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center mr-3">
                      <i className="ri-fire-line text-red-600 text-xl"></i>
                    </div>
                    <span className="font-semibold text-gray-800">Yangın Güvenliği</span>
                  </div>
                  <p className="text-sm text-gray-600">Yangın önleme ve müdahale eğitimi, acil durum prosedürleri</p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-red-100 hover:shadow-lg transition-shadow">
                  <div className="flex items-center mb-3">
                    <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center mr-3">
                      <i className="ri-heart-pulse-line text-red-600 text-xl"></i>
                    </div>
                    <span className="font-semibold text-gray-800">İlkyardım Eğitimi</span>
                  </div>
                  <p className="text-sm text-gray-600">Acil durum müdahale teknikleri ve temel ilkyardım uygulamaları</p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-red-100 hover:shadow-lg transition-shadow">
                  <div className="flex items-center mb-3">
                    <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center mr-3">
                      <i className="ri-alert-line text-red-600 text-xl"></i>
                    </div>
                    <span className="font-semibold text-gray-800">Acil Durum Eğitimleri</span>
                  </div>
                  <p className="text-sm text-gray-600">Deprem, yangın ve diğer acil durumlar için hazırlık eğitimleri</p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-red-100 hover:shadow-lg transition-shadow">
                  <div className="flex items-center mb-3">
                    <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center mr-3">
                      <i className="ri-briefcase-line text-red-600 text-xl"></i>
                    </div>
                    <span className="font-semibold text-gray-800">Meslek Eğitimi ve MYK</span>
                  </div>
                  <p className="text-sm text-gray-600">Mesleki yeterlilik belgesi ve sertifikalı meslek eğitimleri</p>
                </div>
              </div>
            </div>
          </div>

          {/* Consultancy Section */}
          <div>
            <div className="bg-gradient-to-br from-sky-50 to-sky-100 rounded-2xl p-8 border border-sky-200">
              <div className="flex items-center justify-center mb-8">
                <div className="w-16 h-16 bg-gradient-to-br from-sky-500 to-sky-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-settings-line text-2xl text-white"></i>
                </div>
                <h3 className="text-3xl font-bold text-gray-800">Danışmanlık Hizmetleri</h3>
              </div>
              <p className="text-gray-700 leading-relaxed mb-8 text-center max-w-3xl mx-auto">
                İşletmenizin ihtiyaçlarına özel danışmanlık hizmetleri ile sürdürülebilir 
                güvenlik kültürü oluşturmanıza destek oluyoruz.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <div className="bg-white rounded-lg p-6 shadow-sm border border-sky-100 hover:shadow-lg transition-shadow">
                  <div className="flex items-center mb-3">
                    <div className="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center mr-3">
                      <i className="ri-leaf-line text-sky-600 text-xl"></i>
                    </div>
                    <span className="font-semibold text-gray-800">Çevre Danışmanlığı</span>
                  </div>
                  <p className="text-sm text-gray-600">Çevresel etki değerlendirmesi ve sürdürülebilirlik danışmanlığı</p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-sky-100 hover:shadow-lg transition-shadow">
                  <div className="flex items-center mb-3">
                    <div className="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center mr-3">
                      <i className="ri-flask-line text-sky-600 text-xl"></i>
                    </div>
                    <span className="font-semibold text-gray-800">Ortam Ölçümleri</span>
                  </div>
                  <p className="text-sm text-gray-600">Periyodik kontrol ve ölçümler, çalışma ortamı analizleri</p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-sky-100 hover:shadow-lg transition-shadow">
                  <div className="flex items-center mb-3">
                    <div className="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center mr-3">
                      <i className="ri-checkbox-circle-line text-sky-600 text-xl"></i>
                    </div>
                    <span className="font-semibold text-gray-800">Periyodik Kontroller</span>
                  </div>
                  <p className="text-sm text-gray-600">Düzenli güvenlik kontrolleri ve bakım takibi</p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-sky-100 hover:shadow-lg transition-shadow">
                  <div className="flex items-center mb-3">
                    <div className="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center mr-3">
                      <i className="ri-alert-line text-sky-600 text-xl"></i>
                    </div>
                    <span className="font-semibold text-gray-800">Tehlikeli Madde Danışmanlığı</span>
                  </div>
                  <p className="text-sm text-gray-600">Güvenlik ve risk yönetimi, tehlikeli madde kontrolü</p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-sky-100 hover:shadow-lg transition-shadow">
                  <div className="flex items-center mb-3">
                    <div className="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center mr-3">
                      <i className="ri-shield-line text-sky-600 text-xl"></i>
                    </div>
                    <span className="font-semibold text-gray-800">Hırdavat ve KKD</span>
                  </div>
                  <p className="text-sm text-gray-600">Kişisel koruyucu donanım seçimi ve tedarik danışmanlığı</p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-sky-100 hover:shadow-lg transition-shadow">
                  <div className="flex items-center mb-3">
                    <div className="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center mr-3">
                      <i className="ri-fire-line text-sky-600 text-xl"></i>
                    </div>
                    <span className="font-semibold text-gray-800">PKD ve ATEX Çözümleri</span>
                  </div>
                  <p className="text-sm text-gray-600">Patlamadan korunma dokümanı ve ATEX uyumluluk danışmanlığı</p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <div className="text-center mt-16">
            <Link 
              to="/iletisim"
              className="inline-flex items-center bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <span>Ücretsiz Danışmanlık Alın</span>
              <i className="ri-arrow-right-line ml-3 text-xl"></i>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default HomePage;
